module.exports = "/images/house.svg?343dfe8b1327b6d1f3766c0430eb2be9";